import { AfterViewChecked, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatLegacyTabGroup as MatTabGroup } from '@angular/material/legacy-tabs';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject, takeUntil } from 'rxjs';

@Component({
	selector: 'app-order',
	templateUrl: './order.component.html',
	styleUrls: ['./order.component.scss']
})
export class OrderComponent implements OnInit, AfterViewChecked, OnDestroy {

	@ViewChild(MatTabGroup, { static: true }) private matTabGroup: MatTabGroup;

	public m_selectedOrder: string = '';
	public m_selectedTab: number = 0;

	private readonly m_subscriptionsSubject = new Subject();


	constructor(
		private router: Router,
		private route: ActivatedRoute,
	) { }

	ngOnInit(): void {

		this.route.queryParams.pipe(takeUntil(this.m_subscriptionsSubject)).subscribe({
			next: (value) => {
				console.log(value);
				if (value.selectedOrder) {
					this.m_selectedOrder = value.selectedOrder;
					this.m_selectedTab = 1;
				} else {
					this.m_selectedOrder = null;
					this.m_selectedTab = 0;
				}
			}
		});
	}

	/**
	 * Die InkBar in der TabBar wird neu positioniert.
	 */
	public ngAfterViewChecked() {
		this.matTabGroup.realignInkBar();
	}

	ngOnDestroy(): void {
		this.m_subscriptionsSubject.next(null);
		this.m_subscriptionsSubject.complete();
	}

	/**
	 * Es wird in OrderDetail gewechselt. Der Tab wird gesetzt.
	 * @param p_order OID der Order
	 */
	public orderSelected(p_order: string): void {
		// wenn die selbe Bestellung angeschaut werden soll wird nur der Tab gewechselt
		if (this.m_selectedOrder === p_order) {
			this.m_selectedTab = 1;
		} else {
			this.router.navigate(['bestellung'], { queryParams: { selectedOrder: p_order }, onSameUrlNavigation: 'reload' });
			// this.m_selectedOrder = p_order;
			// this.m_selectedTab = 1;
		}
	}

	/**
	 * Wechselt in den ersten Tab zurück.
	 * @param p_exit Boolean true wenn OrderDetail geschlossen wurde.
	 */
	public exitOrderDetail(p_exit: boolean): void {
		if (p_exit) {
			this.m_selectedTab = 0;
		}
	}

}
